// src/modules/expenses.js
//
// Phase 57 — Expense reporting & procurement module.
// Subscribes the expenseReports + expenseConfig stores at login so the bell
// indicator + page deep links work without a cold start.

export default {
  id: 'expenses',
  label: 'Expenses',

  stores: {
    expenseReportsStore: {
      import: () => import('@/stores/expenseReportsStore'),
      storeId: 'expenseReports',
      init: store => {
        store.subscribe()
      },
      cleanup: store => {
        store.unsubscribeAll?.()
      },
    },
    expenseConfigStore: {
      import: () => import('@/stores/expenseConfigStore'),
      storeId: 'expenseConfig',
      init: store => {
        store.subscribe()
      },
      cleanup: store => {
        store.unsubscribeAll?.()
      },
    },
  },

  globalComponents: {},

  routes: ['ExpenseReports'],

  nav: [],
}
